import {
	Swiper,
	Pagination,
	Autoplay, 
	Thumbs,
	Navigation
} from 'swiper';
Swiper.use([Pagination, Autoplay, Thumbs, Navigation]);
$(document).ready(function () {

	/** product swipers  */
	var thumbnails = new Swiper(".thumbnails", {
		spaceBetween: 10,
		slidesPerView: 6,
		freeMode: true,
		watchSlidesProgress: true,
		slideToClickedSlide: true
	});

	var bigImage = new Swiper(".big-image", {
		spaceBetween: 10,
		navigation: {
			nextEl: ".big-image .swiper-button-next",
			prevEl: ".big-image .swiper-button-prev",
		},
		thumbs: {
			swiper: thumbnails,
		},
	});

	//here you get your div(thumb) with data set
	let swiperData = document.querySelectorAll('.swiper-slide-thumbs');
	//here i create a for to get my click and show my slider with my data
	for (let i = 0, lgt = swiperData.length; i < lgt; i++) {
		swiperData[i].onclick = function () {
			var swiperGetData = swiperData[i].getAttribute('data-slide') - 1;
			bigImage.slideTo(swiperGetData, 400);
		}
	}
	/** // product swipers  */

	/** product zoom modal  */


	var productZoomImage = false;
	$('#product-zoom-modal').on('shown.bs.modal', function () {
		const currentSlide = bigImage.realIndex;
		productZoomImage = new Swiper("#product-zoom-modal .swiper", {
			spaceBetween: 10,
			navigation: {
				nextEl: "#product-zoom-modal .swiper .swiper-button-next",
				prevEl: "#product-zoom-modal .swiper .swiper-button-prev",
			}
		});
		productZoomImage.slideTo(currentSlide, 0);

	})
	$('#product-zoom-modal').on('hide.bs.modal', function () {
		if (productZoomImage) productZoomImage.destroy();
	});

	/** //product zoom modal  */
});

function addServingsToRechargeWidget() {

}

/**
 * Wait for the specified element to appear in the DOM. When the element appears,
 * provide it to the callback.
 *
 * @param selector a jQuery selector (eg, 'div.container img')
 * @param callback function that takes selected element (null if timeout)
 * @param maxtries number of times to try (return null after maxtries, false to disable, if 0 will still try once)
 * @param interval ms wait between each try
 */
function waitForEl(selector, callback, maxtries = false, interval = 100) {
  const poller = setInterval(() => {
    const el = jQuery(selector)
    const retry = maxtries === false || maxtries-- > 0
    if (retry && el.length < 1) return // will try again
    clearInterval(poller)
    callback(el || null)
  }, interval)
}

if (
	window.location.pathname.includes("/products/") &&
	window.price_per_servings.subscription != "" &&
	window.price_per_servings.one_time != ""
) {
	waitForEl(".rc_widget", function () {
		const sub = $(".rc-radio.rc-option__subsave label");
		const once = $(".rc-radio.rc-option__onetime label");

		setTimeout(() => {
			sub.append(
				`<span style="margin-left: 12px; font-size: 13px; color: #d6410f;">(${window.price_per_servings.subscription}/serving)</span>`
			);
			once.append(
				`<span style="margin-left: 12px; font-size: 13px; color: #d6410f;">(${window.price_per_servings.one_time}/serving)</span>`
			);
		}, 150);
	});
}
